var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWiFyLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 17C11.3 17 10.7083 16.7583 10.225 16.275C9.74167 15.7917 9.5 15.2 9.5 14.5C9.5 13.8 9.74167 13.2083 10.225 12.725C10.7083 12.2417 11.3 12 12 12C12.7 12 13.2917 12.2417 13.775 12.725C14.2583 13.2083 14.5 13.8 14.5 14.5C14.5 15.2 14.2583 15.7917 13.775 16.275C13.2917 16.7583 12.7 17 12 17ZM6.35 11.35L4.25 9.2C5.23333 8.21667 6.38767 7.43767 7.713 6.863C9.03833 6.28833 10.4673 6.00067 12 6C13.5327 5.99933 14.962 6.291 16.288 6.875C17.614 7.459 18.768 8.25067 19.75 9.25L17.65 11.35C16.9167 10.6167 16.0667 10.0417 15.1 9.625C14.1333 9.20833 13.1 9 12 9C10.9 9 9.86667 9.20833 8.9 9.625C7.93333 10.0417 7.08333 10.6167 6.35 11.35ZM2.1 7.1L0 5C1.53333 3.43333 3.325 2.20833 5.375 1.325C7.425 0.441666 9.63333 0 12 0C14.3667 0 16.575 0.441666 18.625 1.325C20.675 2.20833 22.4667 3.43333 24 5L21.9 7.1C20.6167 5.81667 19.1293 4.81267 17.438 4.088C15.7467 3.36333 13.934 3.00067 12 3C10.066 2.99933 8.25367 3.362 6.563 4.088C4.87233 4.814 3.38467 5.818 2.1 7.1Z",
    fill: "url(#paint0_linear_10_9)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10_9",
    x1: 24,
    y1: 8.5,
    x2: 0,
    y2: 8.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5236AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E31937"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWiFyLogo);
export default __webpack_public_path__ + "static/media/Wi-Fy-Logo.6a3af9b0a8776a3c99c3b68cab3baa57.svg";
export { ForwardRef as ReactComponent };